import { toast } from "@cobee/cobee-ui";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import approveBenefitRequest from "v2/domain/benefitRequest/useCases/approveBenefitRequest";

type Params = {
  companyId: string;
  requestId: string;
};

export default function useApproveBenefitRequest() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation<void, Error, Params>(
    ({ companyId, requestId }) => {
      return approveBenefitRequest({ companyId, requestId });
    },
    {
      onSuccess: (_data, variables) => {
        toast.show(t("v2.common.the-request-has-been-processed"), {
          type: "success",
          position: "top-right",
        });
        queryClient.invalidateQueries([
          "companyBenefitRequestDetail",
          `${variables.companyId}/${variables.requestId}`,
        ]);
      },
      onError: (_error, variables) => {
        queryClient.invalidateQueries([
          "companyBenefitRequestDetail",
          `${variables.companyId}/${variables.requestId}`,
        ]);
      },
    }
  );
}
